<app-modal
  [isOpen]="isOpen()"
  title="Sair"
  size="small"
  (closed)="closed.emit()"
>
  <div class="logout-modal-content">
    <p class="logout-modal-message">Tem certeza que deseja sair?</p>
    <div class="logout-modal-actions">
      <app-button variant="secondary" label="Cancelar" (clicked)="closed.emit()" />
      <app-button variant="danger" label="Sair" (clicked)="confirm.emit()" />
    </div>
  </div>
</app-modal>
